import React, { useState, useCallback } from "react";
import HttpAction from "modules/utils/HttpAction";
const CompanyContext = React.createContext({
  state: { history: {},shareholder:[]},
  actions: {
    getCompany: () => {},
  },
});

const CompanyProvider = ({ children }) => {
  const [historyList, setHistoryList] = useState([]);
  const [financialList, setFinancialList] = useState([]);
  const [shareholder, setShareholder] = useState([]);
  const [status, setStatus] = useState([]);
  
  const getHistoryList = useCallback((pageInfo) => {
    HttpAction({
      url:"api/member/history/list", 
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setHistoryList(res.data);
      } else {
      }
    });
  }, []);

  const getShareholder = useCallback(() => {
    HttpAction({
      url:"api/member/financial/shareholder", 
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setShareholder(res.data);
      } else {
      }
    });
  }, []);

  const getStatus = useCallback(() => {
    HttpAction({
      url:"api/member/financial/status", 
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setStatus(res.data);
      } else {
      }
    });
  }, []);

  const getFinancialList = useCallback(() => {
    HttpAction({
      url:"api/member/financial/list", 
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setFinancialList(res.data);
      } else {
      }
    });
  }, []);

  const value = {
    state: { historyList, shareholder, status, financialList },
    actions: { getHistoryList, getShareholder, getStatus, getFinancialList },
  };

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
};

const { Consumer: CompanyConsumer } = CompanyContext;

export { CompanyProvider, CompanyConsumer, CompanyContext };

export default CompanyContext;
